<template>
  <multi-input data-mask>
    <column>
      <slot :enabled="enabled">
        <input v-bind="$attrs" :type="inputType">
      </slot>
    </column>
    <suffix>
      <button :aria-checked="(!enabled).toString()" class="btn" data-mask-toggle role="switch" type="button" @click="switchView" aria-label="Show masked response">
        <icon :class="enabled ? 'hide' : 'show'" rel="decoration" />
        <span aria-live="polite"
              class="sr-only"
              data-masked-status>
          {{label}} - Response {{enabled ? 'hidden' : 'shown'}}
        </span>
      </button>
    </suffix>
  </multi-input>
</template>

<script lang="ts">
  import Vue from "vue";

  export default Vue.extend({
    inheritAttrs: false,

    props: {
      initialEnabled: {
        type: Boolean,
        default: true,
      },
      label: {
        type: String,
      },
    },
    data: function () {
      return {
        enabled: this.initialEnabled,
      }
    },
    computed: {
      inputType(): string {
        return this.enabled ? 'password' : this.$attrs.type || 'text'
      },
    },
    methods: {
      switchView() {
        this.enabled = !this.enabled;
        this.$nextTick(() => this.$emit('toggle', this.enabled))
      },
    },
  });
</script>
